'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _reactCookie = require('react-cookie');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CookieStorage = function () {
  function CookieStorage(cookies) {
    (0, _classCallCheck3.default)(this, CookieStorage);
    this.cookiePrefix = '__client__';

    this.cookies = cookies || new _reactCookie.Cookies();
  }

  (0, _createClass3.default)(CookieStorage, [{
    key: 'set',
    value: function set(_ref) {
      var name = _ref.name,
          value = _ref.value,
          expires = _ref.expires;

      this.cookies.set('' + this.cookiePrefix + name, value.toString(), { path: '/', expires: expires });
    }
  }, {
    key: 'setAsBoolean',
    value: function setAsBoolean(_ref2) {
      var name = _ref2.name,
          value = _ref2.value,
          expires = _ref2.expires;

      this.set({ name: name, value: Number(value).toString(), expires: expires });
    }
  }, {
    key: 'get',
    value: function get(_ref3) {
      var name = _ref3.name;

      return this.cookies.get('' + this.cookiePrefix + name);
    }
  }, {
    key: 'getAsNumber',
    value: function getAsNumber(_ref4) {
      var name = _ref4.name;

      return Number(this.get({ name: name }));
    }
  }, {
    key: 'getAsBoolean',
    value: function getAsBoolean(_ref5) {
      var name = _ref5.name;

      return !!this.getAsNumber({ name: name });
    }
  }]);
  return CookieStorage;
}();

exports.default = CookieStorage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/storage.js
// module id = 529
// module chunks = 1